// extracted by mini-css-extract-plugin
module.exports = {"container":"SCurveDescription-module--container--3aL1c","slider":"SCurveDescription-module--slider--2T13I"};